import type { IGatsbyImageData } from 'gatsby-plugin-image';

import { isPreProd, isProd, isTest } from '../env';
import type { Lucid } from '../../types/types';

export type IntegrationItem = {
  id: string;
  title: string;
  image: IGatsbyImageData;
};

const withMarketplaceIntegrations = (
  integrations: Lucid.Query.Hooks.UseMarketplaceIntegrations,
  product?: Lucid.Site.Product,
) =>
  integrations.allMarketplaceIntegration?.nodes?.reduce((prev, curr) => {
    const image = curr.icon48?.childImageSharp?.gatsbyImageData;

    if (product === 'chart' && (isProd() || isTest() || isPreProd())) {
      const imageSources = image?.images?.sources?.map(currentImage => ({
        ...currentImage,
        srcSet: currentImage.srcSet.replaceAll('/static/', '/pages/static/'),
      }));

      const imageFallbackSrc = image?.images?.fallback?.src?.replace('/static/', '/pages/static/');
      const imageFallbackSrcSet = image?.images?.fallback?.srcSet?.replaceAll('/static/', '/pages/static/');

      const udpatedImage = {
        ...image,
        images: {
          ...image?.images,
          fallback: {
            ...image?.images?.fallback,
            src: imageFallbackSrc,
            srcSet: imageFallbackSrcSet,
          },
          sources: imageSources,
        },
      };

      return [...prev, { title: curr.title, image: udpatedImage, id: curr.packageId }] as IntegrationItem[];
    }

    return [...prev, { title: curr.title, image, id: curr.packageId }] as IntegrationItem[];
  }, [] as IntegrationItem[]);

export default withMarketplaceIntegrations;
